module.exports = __webpack_public_path__ + "img/constant-combinator.23f9a579.png";